/**
 * API functions for agent management.
 */

import apiClient from './client';
import type { Agent, AgentCreateRequest, AgentCreateResponse, AgentUpdateRequest, AgentVersionInfo } from '@/types/agent';

const BASE = '/v1/agents';

export async function listAgents(): Promise<Agent[]> {
  const { data } = await apiClient.get<Agent[]>(BASE);
  return data;
}

export async function createAgent(payload: AgentCreateRequest): Promise<AgentCreateResponse> {
  const { data } = await apiClient.post<AgentCreateResponse>(BASE, payload);
  return data;
}

export async function updateAgent(agentId: string, payload: AgentUpdateRequest): Promise<Agent> {
  const { data } = await apiClient.patch<Agent>(`${BASE}/${agentId}`, payload);
  return data;
}

export async function deleteAgent(agentId: string): Promise<void> {
  await apiClient.delete(`${BASE}/${agentId}`);
}

export async function getAgentVersion(): Promise<AgentVersionInfo> {
  const { data } = await apiClient.get<AgentVersionInfo>('/v1/agent/version');
  return data;
}

export async function downloadAgentPackage():Promise<Blob>{
  const {data}=await apiClient.get('/v1/agent/package',{responseType:'blob'});
  return data;
}
